import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getWorksheetReportTemplateConfig } from '../services/config/function';
import { MeasurementTableBlockConfig } from '../services/config/type';
import { worksheetReportTemplateConfigKeys } from '../services/config/key';
import { measurementKeys } from '../services/report/key';
import { localStateKeys } from '../utils/reportviewutils';
import NumericTable from './NumericTable';
import Loader from './Loader';
import '../styles/main.css';
import './Measurement.css';


function Measurement() {
  // get num of studies
  const queryClient = useQueryClient();
  const numBlocks = queryClient.getQueryData<number>(localStateKeys.maxBlocks);
console.log('Measurement : numBlocks = ' + numBlocks);

  const { status : status, data : data, error: error } = useQuery({
    queryKey: worksheetReportTemplateConfigKeys.all,
    queryFn: getWorksheetReportTemplateConfig,
    staleTime: Infinity,
    meta: { numBlocks : numBlocks, numParams : 10 },
  })

  // event handler 
  const handleTestButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    queryClient.invalidateQueries({queryKey: measurementKeys.all});
    event.preventDefault();
    return false;
  }

  // if (isPending) 
  if (status === 'pending') {
    return null;
  }

  // if (isError) 
  if (status === 'error') {
    return <span>Error: {error.message}</span>
  }

  // get sorted measurement configs
  let measTblCfgs = new Array<MeasurementTableBlockConfig>();
  data?.measTblBlkOrder.map((tblId) => {
    measTblCfgs.push(data?.measTblBlkConfig[tblId]);
  });

  return (
    <>
      { 
        (() => {
          console.log('measurement component is now rendering...');
          return null;
        })() && undefined
      }
      <section className="button-section">
        <button 
         onClick={handleTestButtonClick}>
          Test[Full value change]
        </button>
      </section>
      <Loader/>
      <section>
        {measTblCfgs.map((cfg) => (
          <NumericTable targetConfig={cfg} key={cfg.blockName}/>
          //<NumericTable key={cfg.blockName}/>
        ))}
        <p className="read-the-docs">
          Footer part.
        </p>
      </section>
    </>
  )
}

export default Measurement
